/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";

  var search = function search() {
    console.log($("#datefrom").val());
    $f7.request.get('https://temp/json/find.aspx?user=testplxx&pass=123789&drawdatefrom=' + $("#datefrom").val() + '&drawdateto=' + $("#dateto").val()).then(function (res) {
      console.log(res.data);
      var data = JSON.parse(res.data);

      if (data.ALERT != undefined && data.ALERT != "") {
        $f7.dialog.alert(data.ALERT);
      }

      if (data.status == "1") {
        //$f7.dialog.alert(data.receipts[0].details[0].orderID,"Receipt");
        console.log("receipt length" + data.receipts.length);

        for (var i = 0; i < data.receipts.length; i++) {
          receipt += "\n            <tr>\n              <td class=\"label-cell\"><button class=\"button button-fill\">rebuy</button></td>\n              <td class=\"numeric-cell\">" + data.receipts[i].orderID + "</td>\n            </tr>\n            ";
        }

        $update();
      } else {
        $f7.dialog.alert(data.errMsg, "Error");
      }
    });
  };

  $on('pageInit', function () {
    document.getElementById('datefrom').valueAsDate = new Date();
    document.getElementById('dateto').valueAsDate = new Date();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">GD Lottery</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">Bet List</div>
    <div class="block">
      Please fill in the form to show the bet list.
    </div>


    <div class="block-title">
      <span class='en'>Draw Date</span>
      <span class='cn'>抽奖日期</span>
      <span class='tl'>Data soe </span>
    </div>
    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>From</span>
              <span class='cn'>开始</span>
              <span class='tl'>Husi</span>
            </div>
            <div class="item-input-wrap">
              <input type="date"  placeholder="Please choose..." id="datefrom"/>
            </div>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>To</span>
              <span class='cn'>结束</span>
              <span class='tl'>Ba</span>
            </div>
            <div class="item-input-wrap">
              <input type="date"  placeholder="Please choose..." id="dateto"/>
            </div>
          </div>
        </li>   
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">Page</div>
            <div class="item-input-wrap">
              <input type="text" value="" placeholder="Page Number" />
            </div>
          </div>
        </li>    
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button"></button>
            <button class="button button-fill button-active" @click="${search}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
        
      </ul>
    </div>


    <div class="block-title">
      <span class='en'>Search Result</span>
      <span class='cn'>搜索结果</span>
      <span class='tl'>Buka rezultado</span>
    </div>
    <div class="card data-table">
      <table>
        <thead>
          <tr>
            <th class="label-cell">Page</th>
            <th class="numeric-cell">Slip</th>
          </tr>
        </thead>
        <tbody innerHTML=${receipt}>

        </tbody>
      </table>
    </div>

    <div class="block">
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Magni molestiae laudantium dignissimos est nobis delectus nemo ea alias voluptatum architecto, amet similique, saepe iste consectetur in repellat ut minus quibusdam!</p>
      
    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '7ebfe1718f';
export default framework7Component;